// dismissible Bootstrap alert. type: success | warning | danger | info
export default function AlertMessage({ type = "info", onClose, children }) {
  return (
    <div
      className={`alert alert-${type} d-flex justify-content-between align-items-start mt-0 mb-0`}
      role="alert"
    >
      <span>{children}</span>
      {onClose && (
        <button
          type="button"
          className="btn-close"
          aria-label="Dismiss"
          onClick={onClose}
        />
      )}
    </div>
  );
}
